export type AnalysisCapabilities = {
  enabled: boolean;
  providerOrigin: string | null;
  transcriptionProviderOrigin?: string | null;
  documentModel: string | null;
  transcriptionModel: string | null;
  recordingMaxMb: number;
  documentAnalysisMaxMb: number;
  connection?: {
    mode: 'managed';
    status: 'invalid_configuration' | 'unavailable' | 'connected';
    reason: string;
    hubOrigin: string | null;
  };
};
export function analysisUnavailableMessage(
  capabilities: AnalysisCapabilities | null,
): string {
  const connection = capabilities?.connection;
  if (connection?.mode !== 'managed') {
    return 'Der Analyse-Dienst ist noch nicht verbunden. Eure Unterlagen und manuelle Planung funktionieren bereits; die Dienstverbindung wird separat eingerichtet.';
  }
  if (
    connection.status === 'invalid_configuration' ||
    connection.reason === 'invalid_configuration' ||
    connection.reason === 'binding_mismatch'
  ) {
    return 'Die KI-Verbindung muss geprüft werden. Eure Unterlagen bleiben gespeichert; derzeit werden keine Dateien zur Analyse gesendet.';
  }
  if (connection.status === 'unavailable') {
    return 'Die KI-Verbindung ist gerade nicht erreichbar. Eure Unterlagen bleiben gespeichert; versuche es später erneut.';
  }
  return 'Die KI-Verbindung ist eingerichtet. Die Verarbeitung von Dokumenten und Aufnahmen ist noch nicht freigegeben. Eure Unterlagen und manuelle Planung könnt ihr bereits nutzen.';
}
export function analysisOrigins(
  capabilities: AnalysisCapabilities,
  recording = false,
): string[] {
  return [
    ...new Set(
      [
        capabilities.providerOrigin,
        ...(recording
          ? [
              capabilities.transcriptionProviderOrigin ??
                capabilities.providerOrigin,
            ]
          : []),
      ].filter((value): value is string => Boolean(value)),
    ),
  ];
}
// Consent is for named services, not a reusable true/false flag. A changed
// speech service must not inherit consent granted to a document service.
export function analysisConsentBinding(
  capabilities: AnalysisCapabilities,
  recording = false,
): string {
  return JSON.stringify({
    origins: analysisOrigins(capabilities, recording),
    documentModel: capabilities.documentModel,
    ...(recording
      ? { transcriptionModel: capabilities.transcriptionModel }
      : {}),
  });
}
export function analysisServiceLabel(
  capabilities: AnalysisCapabilities,
  recording = false,
): string {
  return analysisOrigins(capabilities, recording).join(' und ');
}
